import { Link } from "react-router-dom";

export default function LegalMentions() {
  return (
    <div className="min-h-screen bg-slate-50 text-slate-900 px-6 py-12">
      <div className="max-w-3xl mx-auto space-y-8">
        <header>
          <p className="text-xs uppercase tracking-[0.2em] text-slate-400 mb-2">
            Informations légales
          </p>
          <h1 className="text-2xl sm:text-3xl font-semibold">Mentions légales</h1>
          <p className="mt-2 text-sm text-slate-500">
            Conformément à la loi n° 2004-575 du 21 juin 2004 pour la confiance dans
            l'économie numérique (LCEN).
          </p>
        </header>

        {/* 1. Éditeur */}
        <section className="bg-white border border-slate-200 rounded-2xl p-6 space-y-2 shadow-sm">
          <h2 className="text-lg font-semibold text-slate-900">1. Éditeur du site</h2>
          <p className="text-sm text-slate-700"><span className="font-medium">Raison sociale :</span> Blackout Games</p>
          <p className="text-sm text-slate-700"><span className="font-medium">Forme juridique :</span> Entrepreneur individuel</p>
          <p className="text-sm text-slate-700"><span className="font-medium">Directeur de la publication :</span> William Jacob Bloch</p>
          <p className="text-sm text-slate-700"><span className="font-medium">Siège social :</span> 94210 Saint-Maur-des-Fossés, France</p>
          <p className="text-sm text-slate-700"><span className="font-medium">SIREN :</span> 942 523 762</p>
          <p className="text-sm text-slate-700"><span className="font-medium">SIRET :</span> 942 523 762 00014</p>
          <p className="text-sm text-slate-700"><span className="font-medium">Activité :</span> Conseil en systèmes et logiciels informatiques (APE 62.02A)</p>
          <p className="text-sm text-slate-700">
            <span className="font-medium">Contact :</span>{" "}
            <a href="mailto:contact@blackout-games.fr" className="text-indigo-600 hover:text-indigo-500">
              contact@blackout-games.fr
            </a>
          </p>
        </section>

        {/* 2. Hébergement */}
        <section className="bg-white border border-slate-200 rounded-2xl p-6 space-y-2 shadow-sm">
          <h2 className="text-lg font-semibold text-slate-900">2. Hébergement</h2>
          <div className="space-y-3 text-sm text-slate-700">
            <div>
              <p className="font-medium">Front-end</p>
              <p>Netlify, Inc. — 512 2nd Street, Suite 200, San Francisco, CA 94107, États-Unis</p>
              <p className="text-slate-500 text-xs mt-0.5">
                <a href="https://www.netlify.com" target="_blank" rel="noopener noreferrer" className="text-indigo-600 hover:text-indigo-500">netlify.com</a>
              </p>
            </div>
            <div>
              <p className="font-medium">Back-end / API</p>
              <p>Render Services, Inc. — 525 Brannan Street, Suite 300, San Francisco, CA 94107, États-Unis</p>
              <p className="text-slate-500 text-xs mt-0.5">
                <a href="https://render.com" target="_blank" rel="noopener noreferrer" className="text-indigo-600 hover:text-indigo-500">render.com</a>
              </p>
            </div>
            <div>
              <p className="font-medium">Nom de domaine</p>
              <p>OVHcloud — 2 rue Kellermann, 59100 Roubaix, France</p>
              <p className="text-slate-500 text-xs mt-0.5">
                <a href="https://www.ovhcloud.com" target="_blank" rel="noopener noreferrer" className="text-indigo-600 hover:text-indigo-500">ovhcloud.com</a>
              </p>
            </div>
          </div>
        </section>

        {/* 3. Propriété intellectuelle */}
        <section className="bg-white border border-slate-200 rounded-2xl p-6 space-y-2 shadow-sm">
          <h2 className="text-lg font-semibold text-slate-900">3. Propriété intellectuelle</h2>
          <p className="text-sm text-slate-700">
            L'ensemble des contenus présents sur ce site (textes, visuels, illustrations,
            scénarios de jeu, logos, marque « Blackout Games », etc.) est la propriété
            exclusive de William Jacob Bloch et est protégé par le droit de la propriété
            intellectuelle.
          </p>
          <p className="text-sm text-slate-700">
            Toute reproduction, diffusion ou utilisation, totale ou partielle, sans
            autorisation écrite préalable est interdite.
          </p>
        </section>

        {/* 4. Contenus IA */}
        <section className="bg-white border border-slate-200 rounded-2xl p-6 space-y-2 shadow-sm">
          <h2 className="text-lg font-semibold text-slate-900">4. Contenus générés par intelligence artificielle</h2>
          <p className="text-sm text-slate-700">
            Certains décors, illustrations et éléments visuels des escape games sont créés
            à l'aide d'outils d'intelligence artificielle, puis sélectionnés et validés par
            l'équipe Blackout Games. Aucun visage réel n'est généré ou utilisé sans
            consentement. Ces visuels sont exclusivement destinés à l'illustration de
            scénarios fictifs.
          </p>
        </section>

        {/* 5. Données personnelles */}
        <section className="bg-white border border-slate-200 rounded-2xl p-6 space-y-2 shadow-sm">
          <h2 className="text-lg font-semibold text-slate-900">5. Données personnelles</h2>
          <p className="text-sm text-slate-700">
            La gestion des données à caractère personnel est détaillée dans la{" "}
            <Link to="/politique-confidentialite" className="text-indigo-600 hover:text-indigo-500 underline">
              Politique de confidentialité
            </Link>.
          </p>
        </section>
      </div>
    </div>
  );
}